var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full",on:{"click":_vm.openFSPicker}},[_c('div',{staticClass:"upload"},[_c('v-icon',{attrs:{"large":"","color":"white"}},[_vm._v("file_upload")]),_c('span',[_vm._v("Upload Image")])],1),_c('hidden-file-input',{ref:"file-input",attrs:{"max-file-size-mb":"1"},on:{"file":function($event){return _vm.processImage($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }